import { Pipe, PipeTransform } from "@angular/core";
import { ServiceData } from "../../providers/services";

@Pipe({
  name: "service",
})
export class ServicePipe implements PipeTransform {

  constructor(
    private serviceData: ServiceData,
  ) { }

  public transform(idService: string, clientId: string) {
    return this.serviceData.getById(clientId, idService);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/service/service.ts